import { orchestrator } from "satcheljs";

import { loadPlaceSucceeded } from "places-explore-operations";
import { setPlace, addServiceCallsCompleted } from "../store";

orchestrator(loadPlaceSucceeded, ({ result }) => {
    setPlace(result.id, result);
    addServiceCallsCompleted(result.id, true);
});
